// extracted by mini-css-extract-plugin
export default {"page-title":"index__page-title___2q-78","pageTitle":"index__page-title___2q-78"};